<template>
  <div>
    <div class="mb-4 flex justify-between text-sm">
      <p>Last views:</p>
      <p v-if="type === ItemType.VIDEO">% Viewed</p>
    </div>
    <div class="flex flex-col gap-4 text-sm">
      <template v-for="(row, index) in groupStats" :key="index">
        <dl class="flex gap-2" v-for="(stat, index) in row" :key="index">
          <dt class="w-40">
            <span class="font-semibold block truncate">{{ stat.email }}</span>
            <span>{{ stat.createdAt }}</span>
          </dt>
          <dd v-if="type === ItemType.VIDEO" class="grow flex gap-2 items-center">
            <div class="w-10 text-right">{{ getPC(stat.viewedPc) }}</div>
            <div class="w-full h-1.5 rounded bg-slate-200 dark:bg-zinc-700">
              <div class="h-1.5 rounded bg-slate-400 dark:bg-zinc-400" :style="{ width: getPC(stat.viewedPc) }"></div>
            </div>
          </dd>
        </dl>
      </template>

      <HorizontalDivider v-if="groupStatsContainsAnonymousUser" class="my-0" />
      <div v-if="groupStatsContainsAnonymousUser" class="flex flex-col gap-3">
        <p>You got an anonymous view. To prevent it you may want to:</p>
        <ul class="list-disc pl-4">
          <li>set <em>Require email</em> option</li>
          <li>share only with <em>Users in your organization</em></li>
          <li>set <em>Only emailed people</em> option</li>
        </ul>
        <a href="#" @click="openShareModalAction(modalProps)" class="font-bold text-base text-blue-500" data-testid="analytics-access-settings"
          >Edit access settings</a
        >
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import HorizontalDivider from '@/storybook/utilities/HorizontalDivider.vue';
import { ItemType, useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { useViewerStatsStore } from '@/modules/viewer/store/useViewerStatsStore';
import { useItemActions } from '@/modules/viewer/composables/useItemActions';

const modalProps = {
  modalProps: {
    selectedTab: '#access-settings',
  },
};

const { type } = storeToRefs(useViewerItemStore());
const { groupStats, groupStatsContainsAnonymousUser } = storeToRefs(useViewerStatsStore());
const { openShareModalAction } = useItemActions();

const getPC = (pc?: number) => {
  return pc ? `${Math.floor(pc)}%` : `0%`;
};
</script>
